module.exports = __webpack_public_path__ + "static/media/icon-quality-yellow.520ca050.svg";